const landAreaUnits = [
  { id: "1", name: "m²" },
  { id: "2", name: "ha" },
];

export default landAreaUnits;
